import React, { Component } from 'react';
import Balance from './balance';
import './collateral.css';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

class NRG extends Component {
  render() {
    return (
      <div className='col s12' style={{}}>
        {this.props.loggedIn ? <Balance/> :
          <div style={{marginTop:'70px'}}>
          <Link to='/'>
            <h5 className='pleaseStart'>
              Create Your Wallet To Start Trading
            </h5>
          </Link>
          </div>
        }

      </div>
		)
  }
}

function mapStateToProps(state) {
  return {
    loggedIn:
      state.passport.wallet.emb &&
      state.passport.wallet.nrg &&
      state.passport.wallet["l-emb"] &&
      Object.keys(state.passport.wallet.emb).length > 0,
  }
}

export default connect(mapStateToProps, {})(NRG);
